import script from "./Enter2faCodeView.vue?vue&type=script&setup=true&lang=js"
export * from "./Enter2faCodeView.vue?vue&type=script&setup=true&lang=js"

import "./Enter2faCodeView.vue?vue&type=style&index=0&id=79cb3e33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cb3e33"]])

export default __exports__